import type { GridApi, IRowNode } from "ag-grid-community";
import React from "react";

import type { CompetencyDict } from "@performyard/service-contracts";

import { SuperRowLayout } from "./SuperRowLayout";

import type { CompetencyAssignmentRow, SuperRowContext } from "./types";

type CompetencySuperRowContentProps = {
	data: CompetencyAssignmentRow;
	node: IRowNode;
	api: GridApi;
	context: SuperRowContext;
	competencies: CompetencyDict;
};

export const CompetencySuperRowContent = ({
	data,
	node,
	api,
	context,
	competencies,
}: CompetencySuperRowContentProps): React.ReactElement => {
	const rowId = data.parentRowId ?? data._rowId;
	const competency = competencies[data.competency_id];

	return (
		<SuperRowLayout
			node={node}
			api={api}
			context={context}
			rowId={rowId}
			description={competency?.description ?? ""}
			levels={competency?.levels ?? []}
			isLevelCurrent={(rank) => data.current_level === rank}
			isLevelExpected={(rank) => data.expected_level === rank}
		/>
	);
};
